import React, { createContext, useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import { config } from '../config';
import { getUserKey } from '../utils/auth';

const UserContext = createContext();

export const useUser = () => {
    return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
    const [profile, setProfile] = useState(null);
    const [isLoadingProfile, setIsLoadingProfile] = useState(true);

    const fetchProfile = async () => {
        const userKey = getUserKey();
        if (!userKey || !userKey.token) {
            setProfile(null);
            setIsLoadingProfile(false);
            return;
        }

        setIsLoadingProfile(true);
        try {
            const response = await fetch(`${config.serverUrl}/api/users/profile/full`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${userKey.token}`,
                },
            });

            const result = await response.json();

            if (response.ok && result.status === "success") {
                setProfile(result.response);
            } else {
                console.error("Failed to fetch user profile:", result.msg);
                setProfile(null);
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
            setProfile(null);
        } finally {
            setIsLoadingProfile(false);
        }
    };

    // Fetch profile on mount if token exists
    useEffect(() => {
        fetchProfile();
    }, []);

    const value = {
        profile,
        isLoadingProfile,
        fetchProfile, // Export so Login.jsx can trigger a reload
        setProfile
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};
